<template>
  <div>
    <LayoutPageHeader 
      :title="`Category: ${category}`" 
      :background-image="'https://cdn-media.geekcafe.com/a0d4d17b-ec8f-4f28-9169-97e3e5bb4d37/person-looking-at-phone-and-at-macbook-pro-1181244_1920x400.jpg'" 
    />

    <main class="archive py-5">
      <div class="container">
        <div class="row mb-4">
          <div class="col-md-12">
            <div class="bg-white p-4 rounded shadow-sm">
              <h2 class="mb-0">
                <i class="fas fa-folder-open me-2" />
                Posts in {{ category }}
              </h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-8">
            <div class="row">
              <div v-for="post in posts" :key="post._path" class="col-md-6 mb-4">
                <BlogCard :post="post" />
              </div>
            </div>
            <!-- Back to blog link -->
            <div class="row mt-4">
              <div class="col-12">
                <NuxtLink to="/blog" class="btn btn-outline-primary">
                  <i class="fas fa-arrow-left me-2" />
                  Back to Blog
                </NuxtLink>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <BlogSidebar />
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router'

const route = useRoute()
const category = route.params.category

definePageMeta({
  layout: 'default',
  title: 'Blog Category'
})

// Fetch posts for this category
const { data: posts } = await useAsyncData(`blog-category-${category}`, () => 
  $fetch(`/api/blog/category/${category}`)
)

// Set page metadata
useHead({
  title: `Category: ${category} | Geek Cafe`,
  meta: [
    { name: 'description', content: `Blog posts in the ${category} category` }
  ]
})
</script>

<style scoped>
/* Any additional styling specific to the category page can go here */
</style>
